<template>
  <div class="unusual">
    <CustomTitle :title="titletxt" />
    <div class="chart">
      <Echart id="pieAA" :options="option" height="100%" width="100%" />
    </div>
    <div style="padding:0 42px">
      <div class="statistic">
      <div class="statistic-con">
        <div class="statistic-item">
          <span class="num">{{ errorNumOfTimer }}</span
          >{{txtunit}}
        </div>
        <div class="statistic-item">
          <span class="num">{{ errorQuantity }}</span>
          件
        </div>
        <div class="statistic-item">
          <span class="num">{{ errorPrice }}</span>
          元
        </div>
      </div>
    </div>
    </div>
  </div>
</template>

<script>
import Echart from '@/common/echart'
import config from '@/js/config'
import CustomTitle from '@/components/CustomTitle'
export default {
  name: 'Unusual',
  data () {
    return {
      avgNum: 0,
      sumpcs: 0,
      unit: '',
      txtunit: '次',
      opt: [],
      optunit: [],
      runpcs: -1,
      timer: '',
      allrun: 0,
      compid: -1,
      dept: '',
      option: {},
      errorNumOfTimer: 0,
      errorQuantity: 0,
      errorPrice: 0,
      requestTimer: null,
      retryTimer: null,// 重试延时器
      titletxt:'品质异常统计',
      requestUrl:''
    }
  },
  components: {
    CustomTitle,
    Echart
  },
  watch: {},
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.dept =window.localStorage.getItem('bsmdept')
    if(this.dept=="PMD")
    {
      this.titletxt='加工中工件部门分布图'
      this.txtunit='款'
      this.getdeptfun();
    }
    else
      this.getqafun()
    this.starttime()
  },
  methods: {
    pieBtn (da) {
      this.option = {
        color: ['#ffa631', '#955539', '#ffc773', '#eedeb0', '#ca6924', '#8c4356', '#ff4c00', '#b0a4e3'],
        grid: {
          // top: '0',
          // left: '0%',
          // right: '0%',
          // bottom: '10%',
          containLabel: true
        },
        legend: {
          itemHeight: 8, // 图例icon高度
          itemWidth: 8, // 图例icon宽度
          orient: 'vertical',
          show: true,
          itemGap: 12,
          right: '10%',
          top: 'middle',
          type: 'scroll', // 可滚动翻页的图例
          pageIconSize: 8, // 翻页按钮大小
          pageIconColor: '#2C86FF', // 翻页箭头颜色
          pageIconInactiveColor: 'rgba(44,132,251,0.40)', // 翻页（即翻页到头时箭头的颜色
          pageTextStyle: {
            color: '#999' // 翻页数字颜色
          },
          textStyle: {
            rich: {
              title: {
                fontSize: 12,
                color: '#fff'
              },
              valueColor: {
                fontSize: 12,
                color: '#48E5E5'
              }
            }
          },

          formatter: function (p) {
            const total = da.reduce((pre, cur) => {
              return pre + cur.value
            }, 0)            
            const currentItem = da.find(item => item.name === p)
            return `{title|${p}} {valueColor|${currentItem.value}次 (${(
              (currentItem.value / total) *
              100
            ).toFixed(0)}%)}`
          }
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['25%', '48%'],
            label: {
              show: false
            },
            data: da // [name:'',value:10,5,6,8,9]                   ,
          }
        ]
      }
    },
    pieBtndept (da) {
      var that=this
      this.option = {
        color: ['#ffa631', '#955539', '#ffc773', '#eedeb0', '#ca6924', '#8c4356', '#ff4c00', '#b0a4e3'],
        grid: {
          // top: '0',
          // left: '0%',
          // right: '0%',
          // bottom: '10%',
          containLabel: true
        },
        legend: {
          itemHeight: 8, // 图例icon高度
          itemWidth: 8, // 图例icon宽度
          orient: 'vertical',
          show: true,
          itemGap: 12,
          right: '10%',
          top: 'middle',
          type: 'scroll', // 可滚动翻页的图例
          pageIconSize: 8, // 翻页按钮大小
          pageIconColor: '#2C86FF', // 翻页箭头颜色
          pageIconInactiveColor: 'rgba(44,132,251,0.40)', // 翻页（即翻页到头时箭头的颜色
          pageTextStyle: {
            color: '#999' // 翻页数字颜色
          },
          textStyle: {
            rich: {
              title: {
                fontSize: 12,
                color: '#fff'
              },
              valueColor: {
                fontSize: 12,
                color: '#48E5E5'
              }
            }
          },

          formatter: function (p) {
            const total = da.reduce((pre, cur) => {
              return pre + cur.value
            }, 0)            
            const currentItem = da.find(item => item.name === p)
            return `{title|${p}} {valueColor|${currentItem.value}款${(
              (currentItem.value / total) *
              100
            ).toFixed(0)}%}` //${that.unit}
          }
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['25%', '48%'],
            label: {
              show: false
            },
            data: da // [name:'',value:10,5,6,8,9]                   ,
          }
        ]
      }
    },
    pieBtnpcs (da) {
      this.option = {
        color: ['#ffa631', '#955539', '#ffc773', '#eedeb0', '#ca6924', '#8c4356', '#ff4c00', '#b0a4e3'],
        grid: {
          // top: '0',
          // left: '0%',
          // right: '0%',
          // bottom: '10%',
          containLabel: true
        },
        legend: {
          itemHeight: 8, // 图例icon高度
          itemWidth: 8, // 图例icon宽度
          orient: 'vertical',
          show: true,
          itemGap: 12,
          right: '10%',
          top: 'middle',
          type: 'scroll', // 可滚动翻页的图例
          pageIconSize: 8, // 翻页按钮大小
          pageIconColor: '#2C86FF', // 翻页箭头颜色
          pageIconInactiveColor: 'rgba(44,132,251,0.40)', // 翻页（即翻页到头时箭头的颜色
          pageTextStyle: {
            color: '#999' // 翻页数字颜色
          },
          textStyle: {
            rich: {
              title: {
                fontSize: 12,
                color: '#fff'
              },
              valueColor: {
                fontSize: 12,
                color: '#48E5E5'
              }
            }
          },

          formatter: function (p) {
            const total = da.reduce((pre, cur) => {
              return pre + cur.value
            }, 0)            
            const currentItem = da.find(item => item.name === p)
            return `{title|${p}}  {valueColor|${currentItem.value}件${(
              (currentItem.value / total) *
              100
            ).toFixed(0)}%}`
          }
        },
        series: [
          {
            type: 'pie',
            radius: '55%',
            center: ['25%', '48%'],
            label: {
              show: false
            },
            data: da // [name:'',value:10,5,6,8,9]                   ,
          }
        ]
      }
    },
    getqafun () {
      clearTimeout(this.retryTimer)
      this.compid =window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
      var pa = {
        datekind: 1,
        dst: '',
        ded: '',
        compid: this.compid,
        kind: -1
      }
      this.axios({
        method: 'post',
        // params: pa,
        url: this.requestUrl+'/admin.php/Bigsreen/QAdeptSumFun?datekind=1&compid='+this.compid+'&dst=&ded=&kind=-1'
      })
        .then((Response) => {
          var qa = JSON.parse(Response.data)
          this.opt = qa
          this.unit = '件'
          this.pieBtn(this.opt['异常数量'])
          this.runpcs = 1

          this.errorNumOfTimer = qa['异常次数'].reduce((total, obj) => {
            return obj.value + total
          }, 0)

          this.errorQuantity = qa['异常数量'].reduce((total, obj) => {
            return obj.value + total
          }, 0)

          this.errorPrice = qa['异常金额'].reduce((total, obj) => {
            return obj.value + total
          }, 0)
        })
        .catch((error) => {
          console.log(error+" Unusual")
          this.retryTimer = setTimeout(() => {
            this.getqafun()
          }, config.retryTime)
        })
    },
    getdeptfun () {
      clearTimeout(this.retryTimer)
      this.compid = window.localStorage.getItem('bsmcompid')
      this.dept = window.localStorage.getItem('bsmdept')
     
      var pa = {
        datekind: 1,
        dst: '',
        ded: '',
        compid: this.compid,
        kind: -1
      }
      this.axios({
        method: 'post',
        // params: pa,
        url: this.requestUrl+'/admin.php/Bigsreen/partatdeptfun?datekind=1&compid='+this.compid+'&dst=&ded=&kind=-1'
      })
        .then((Response) => {
          var qa = JSON.parse(Response.data)
          this.opt = qa
          this.unit = '款'
          this.pieBtndept(this.opt['异常次数'])
          this.runpcs = 1

          this.errorNumOfTimer = qa['异常次数'].reduce((total, obj) => {
            return obj.value + total
          }, 0)

          this.errorQuantity = qa['异常数量'].reduce((total, obj) => {
            return obj.value + total
          }, 0)
          this.errorPrice =0
          // this.errorPrice = qa['异常金额'].reduce((total, obj) => {
          //   return obj.value + total
          // }, 0)
        })
        .catch((error) => {
          console.log(error+ "Unusual dept")
          this.retryTimer = setTimeout(() => {
            this.getdeptfun()
          }, config.retryTime)
        })
    },


    starttime () {
      this.timer = setInterval(() => {
        

        if (this.runpcs < 0 || this.allrun > 60) {
          this.allrun = 0
        }


        if (this.runpcs === 0) {
          // console.log('异常数量')
          this.unit = '件'
          this.pieBtnpcs(this.opt['异常数量'])
          this.runpcs = 1
        } else {
          // console.log('异常次数')
          this.unit = '次'
          if(this.dept=="PMD")
              this.pieBtndept(this.opt['异常次数'])
          else
              this.pieBtn(this.opt['异常次数'])
          this.runpcs = 0
        }



        this.allrun = this.allrun + 1
      }, 30000)
    }
  },
  mounted () {
    this.requestTimer = setInterval(() => {
      if(this.dept=="PMD")
      {
        this.getdeptfun();

      }
      else
        this.getqafun()
     
    }, config.refreshTime.unusual)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    clearInterval(this.requestTimer)
    clearTimeout(this.retryTimer)
  }
}
</script>

<style scoped lang="less">
.unusual {
  display: flex;
  flex-direction: column;
  .chart {
    flex: 1;
  }
  .statistic {
    padding: 0px 50px;
    height: 42px;
    background-image: url("~@/assets/images/bigscreenSales/title.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    &-con {
      width: 100%;
      display: flex;
      justify-content: space-between;
      .statistic-item {
        font-family: "D-DIN";
        font-weight: 400;
        font-size: 12px;
        color: #c6d1db;
        .num {
          height: 30px;
          font-weight: 700;
          font-size: 24px;
          line-height: 30px;
          color: #f3f6fa;
          margin-right: 4px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/Unusual.vue